import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield } from 'react-icons/fi';
import logo from '../assets/logo.png';

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen font-sans">
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-6 py-4">
          <Link to="/">
            <img src={logo} alt="Jaapand-e" className="h-8" />
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-6 py-12 max-w-4xl">
        <div className="bg-white p-8 sm:p-12 rounded-2xl shadow-lg">
          <div className="text-center mb-10">
            <FiShield className="mx-auto h-12 w-12 text-brand-blue" />
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-4">Politique de Confidentialité</h1>
            <p className="text-gray-500 mt-2">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>

          <div className="prose prose-lg max-w-none text-gray-700">
            <p>
              Bienvenue sur Jaapand-e. Votre confiance est importante pour nous, et nous nous engageons à protéger la confidentialité et la sécurité de vos informations personnelles. Cette politique de confidentialité décrit comment nous collectons, utilisons et protégeons vos données.
            </p>

            <h2>1. Les données que nous collectons</h2>
            <p>Nous collectons deux types d'informations :</p>
            <ul>
              <li><strong>Informations de compte :</strong> Lorsque vous vous inscrivez, nous collectons votre nom d'utilisateur, votre adresse e-mail et le nom de votre boutique.</li>
              <li><strong>Données de gestion :</strong> En utilisant notre service, vous nous confiez des données relatives à votre activité commerciale, telles que les informations sur vos produits (nom, prix, quantité), vos ventes, vos clients (nom, téléphone), vos dépenses et vos fournisseurs.</li>
            </ul>

            <h2>2. Comment nous utilisons vos données</h2>
            <p>Vos données sont utilisées exclusivement pour :</p>
            <ul>
              <li><strong>Fournir et améliorer le service :</strong> Vos données de gestion sont le cœur de l'application. Nous les traitons pour vous fournir les tableaux de bord, les rapports et les fonctionnalités de gestion.</li>
              <li><strong>Communiquer avec vous :</strong> Nous utilisons votre e-mail pour vous envoyer des informations importantes sur votre compte, des mises à jour du service ou pour répondre à vos demandes de support.</li>
              <li><strong>Assurer la sécurité :</strong> Nous utilisons les informations de compte pour sécuriser votre accès à la plateforme.</li>
            </ul>

            <h2>3. Partage et divulgation des données</h2>
            <p>
              <strong>Vos données commerciales sont votre propriété.</strong> Nous ne vendons, n'échangeons, ni ne transférons vos données de gestion ou vos informations personnelles à des tiers. La seule exception concerne les obligations légales si nous y sommes contraints par la loi.
            </p>

            <h2>4. Sécurité de vos données</h2>
            <p>
              La sécurité de vos données est notre priorité absolue. Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos informations :
            </p>
            <ul>
              <li>Les mots de passe sont chiffrés (hachés) et ne sont jamais stockés en clair.</li>
              <li>Les communications entre votre navigateur et nos serveurs sont chiffrées via HTTPS.</li>
              <li>L'accès à la base de données est strictement contrôlé.</li>
            </ul>
            <p>
              Pour l'authentification, nous utilisons un jeton (token) stocké localement dans votre navigateur (`localStorage`). Ce jeton est essentiel pour vous maintenir connecté.
            </p>

            <h2>5. Vos droits sur vos données</h2>
            <p>
              Conformément à la législation en vigueur, vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Vous pouvez modifier la plupart de vos informations directement depuis votre profil. Pour toute autre demande, y compris la suppression de votre compte, veuillez nous contacter.
            </p>

            <h2>6. Conservation des données</h2>
            <p>
              Nous conservons vos données tant que votre compte est actif. Si vous décidez de supprimer votre compte, toutes vos données (compte et données de gestion) seront définitivement supprimées de nos systèmes après une courte période de sécurité.
            </p>

            <h2>7. Contact</h2>
            <p>
              Pour toute question relative à cette politique de confidentialité, veuillez nous contacter à l'adresse <a href="mailto:contact@jaapand-e.com">contact@jaapand-e.com</a>.
            </p>
          </div>
        </div>
      </main>

      <footer className="text-center py-6 text-gray-500 text-sm">
        <p>&copy; {new Date().getFullYear()} Jaapand-e. Tous droits réservés.</p>
        <Link to="/" className="text-brand-blue hover:underline mt-2 inline-block">Retour à l'accueil</Link>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;